"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModelBuilder = void 0;
const Navigator_1 = require("../navigator/Navigator");
/**
 *
 * **Typescript Generics:**
 * - ___StoreUnitClassT___ - type of the store unit class e.g. `typeof UserInfoStoreUnit`
 * - ___BackT___ - (optional)
 * - ___RootT___ - (optional)
 */
class BaseModelBuilder extends Navigator_1.Navigator {
    constructor(StoreUnit, back, root) {
        super(back, root);
        this.model = this._createNewModelObject();
        this.associatedObjects = [];
        this.StoreUnit = StoreUnit;
    }
    valid() {
        Object.assign(this.model, this._createValidModelAttributes());
        this.associatedObjects = this._createAssociatedObjects(this.model);
        return this;
    }
    toView() {
        // Typescript cannot infer the generic return value of `this.toStoreUnit().toView()`
        // by itself (it collapses the type to the default return value `Partial<DefaultStoreObject>`).
        // Hence we need to manually forward the generic return value of `toView`
        return this.toStoreUnit().toView();
    }
    toStoreObject() {
        // Typescript cannot infer the generic return value of `this.toStoreUnit().toStoreObject()`
        // by itself (it collapses the type to the default return value `DefaultStoreObject`).
        // Hence we need to manually forward the generic return value of `toStoreObject`
        return this.toStoreUnit().toStoreObject();
    }
    toStoreUnit() {
        return new this.StoreUnit(this.model);
    }
    getAssociatedStoreUnits() {
        return this.associatedObjects;
    }
    // override to create additional objects
    _createAssociatedObjects(model) {
        return [];
    }
    _createNewModelObject() {
        throw new Error('_createNewModelObject() must be overridden to create a valid new empty Model object');
    }
    _createValidModelAttributes() {
        throw new Error('_createValidModelAttributes() must be overridden to create a valid set of model attributes.');
    }
}
exports.BaseModelBuilder = BaseModelBuilder;
